module.exports = __webpack_public_path__ + "static/media/spot3.1bda5735.webp";